import { useMemo } from "react";
import { Loading } from "react-migration/components/Loading";
import { SelectionFeature } from "src/js/stores/map/store";
import { PlanningApplication } from "react-migration/domains/planning/types";
import { usePlanningApplicationsSummaryByGeometry } from "../SelectionSidebar/usePlanningApplicationsSummaryByGeometry";
import { formatSummary } from "./util/formatSummary";
import { SummaryError } from "./components/SummaryError";
import { Summary } from "./components/Summary";
import { useBetaFeatureFlag } from "react-migration/lib/user/useFeatureFlag";
import Feature from "src/js/stores/user/Feature";
import { SummaryType } from "react-migration/components/AIResponse/SummaryType";

type PlanningApplicationsSummaryType = {
  selection: SelectionFeature;
  referenceApplications: PlanningApplication[];
  setDetailSelection: (selection: SelectionFeature) => void;
};

export const PlanningApplicationsSummary = ({
  selection,
  referenceApplications,
  setDetailSelection,
}: PlanningApplicationsSummaryType) => {
  const useAiPlanningSummary = useBetaFeatureFlag(Feature.aiPlanningSummaryBeta);
  const { data, loading } = usePlanningApplicationsSummaryByGeometry(selection?.feature?.geometry ?? null, true);

  const formattedContent = useMemo(() => {
    if (useAiPlanningSummary && data) {
      return [{ content: (data as any).summary, type: "text" }] as SummaryType[];
    }
    return formatSummary({ data, referenceApplications });
  }, [data, referenceApplications, useAiPlanningSummary]);

  if (loading) {
    return (
      <div className="p-6">
        <Loading />
      </div>
    );
  }

  return (
    <div className="relative p-2">
      {!loading && formattedContent.length ? (
        <Summary content={formattedContent} selection={selection} setDetailSelection={setDetailSelection} />
      ) : (
        <SummaryError />
      )}
    </div>
  );
};
